import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import './PageTitle.scss'

const PageTitle = ({ text, className }) => {
  const { color, colabelNeutralDark } = useContext(ClientContext)

  return <h2 className={classNames('page-title', className)} style={ color && { color: colabelNeutralDark }}>{text}</h2>
}

export default PageTitle
